export default function scrollToTop() {
  window.history.scrollRestoration = 'manual'
  document.body.scrollTop = 0 // For Safari
  document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
}
